import { GET_NAI_KPI_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getNonconformanceAndInvestigationKPIDataAPI = async (): Promise<any[]> => {
    const response = await axios.get(GET_NAI_KPI_DATA_API);
    return response.data;
};

export const getNonconformanceAndInvestigationKPIDataByPeriodAPI = async (year: number, quarter: number): Promise<any[]> => {
    const response = await axios.get(`${GET_NAI_KPI_DATA_API}/${year}/${quarter}`);
    return response.data;
};
